import { render } from "./WeightInput.vue?vue&type=template&id=c8afb376&scoped=true"
import script from "./WeightInput.vue?vue&type=script&lang=js"
export * from "./WeightInput.vue?vue&type=script&lang=js"

import "./WeightInput.vue?vue&type=style&index=0&id=c8afb376&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8afb376"]])

export default __exports__